'use client';

import { useEffect, useState } from 'react';

import ButtonNormal from '@/components/common/ui/buttons/ButtonNormal';
import Quote from '@/components/common/ygen/sections/quote/Quote';
import Modal from 'react-bootstrap/Modal';
import reactHtmlParser from 'react-html-parser';
import styled from 'styled-components';

const StockSingle = ({ title,des, link, img, color }) => {

	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		if (window.location.hash === '#get-a-quote-stock') {
			setModalIsOpen(true);
		}
	}, []);

	return (
		<StyledStockSingle color={color} className="stock-single  d-flex flex-wraps ">
			<div className="image-item">
				<div className="image-wrapper">
					<img src={img ? img : '/images/static/blur.jpg'} alt={title ? title.replace(/<[^>]*>/g, '') : ''} />
				</div>

			</div>
			<div className="middle-content">
				<h5>{reactHtmlParser(title ? title : 'Baumer Temperature Gauges')}</h5>
				<p className="details">
					Details
				</p>
				{
					des ?
						reactHtmlParser(des) : reactHtmlParser('<p>PLCnext Industrial Edge Computer with Intel® Celeron® N3350 processor.  This small form factor programmable edge device supports IEC 61131-3,  MATLAB Simulink, C/C++, and is perfect for protocol converting, data  collection, and cloud computing.</p>')
				}

			</div>
			<div className="last-content">
				<div className="quotes">
					<ButtonNormal 	onClick={(e) => {
						e.preventDefault();
						window.history.pushState(null, '', '#get-a-quote-stock'); // updates URL
						setModalIsOpen(true); // opens modal
					}} hoverBackground={'#152637'} background={'#DD223F'} color={'white'} text={'Request a Quote'} src={'#get-a-quote-stock'}/>
				</div>
				{
					link &&
					<ButtonNormal src={`${link}`} hoverBackground={'#DD223F'} background={'white'} color={'#DD223F'} text={'Product Details'} margin={'20px 0 0'}/>

				}
			</div>


			<Modal interest={title} className={'modal-video'} show={modalIsOpen}onclick={() => {
				setModalIsOpen(false);
				window.location.hash = ''; // fallback method
			}}>
				<Modal.Body className={'video'}>
					<Quote   interest={title} onclick={() => {
						setModalIsOpen(false);
						window.location.hash = ''; // fallback method
					}} />
				</Modal.Body>

			</Modal>
		</StyledStockSingle>
	);
};

const StyledStockSingle = styled.div`
    //width: 100%;
    gap: 30px;
    padding-bottom: 40px;
    border-bottom: 1px solid #152637;
    margin-bottom: 40px;

    .image-item {
        flex: 0 0 calc(25% - 15px);
        max-width: calc(25% - 15px);
        padding-right: 5%;

        .image-wrapper {
            position: relative;
            padding-top: calc(170 / 170 * 100%);
            border: 1px solid #152637;

            img {
                position: absolute;
                inset: 0;
                height: 100%;
                width: 90%;
                margin: auto;
                object-fit: contain;
            }
        }

		@media(max-width: 767px){
            flex: 0 0 calc(100% - 15px);
            max-width: calc(100% - 15px);
		}
    }


    .middle-content {
        flex: 0 0 calc(50% - 15px);
        max-width: calc(50% - 15px);

        .details {
            font-weight: 400;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0;
            color: #15263780;
        }
        font-weight: 500;
        font-size: 1rem; /* 16px */
        line-height: 1.5rem; /* 24px */
        letter-spacing: 0;
        color: #152637;
        p {
            font-weight: 500;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0;
            color: #152637;
        }

        h5 {
            font-weight: 700;
            font-size: 1.25rem; /* 20px */
            line-height: 1.75rem; /* 28px */
            letter-spacing: 0;
            margin-bottom: 20px;
        }

        @media(max-width: 767px){
            flex: 0 0 calc(100% - 15px);
            max-width: calc(100% - 15px);
        }
    }

    .last-content {
		flex: 0 0 calc(25% - 15px);
		max-width: calc(25% - 15px);
		text-align: right;

        @media(max-width: 767px){
            flex: 0 0 calc(100% - 15px);
            max-width: calc(100% - 15px);
        }

    }


    @media(max-width: 767px){
 		flex-direction: column;
    }

`;
export default StockSingle;
